import { render, staticRenderFns } from "./AddSquad.vue?vue&type=template&id=e4496566&scoped=true&"
import script from "./AddSquad.vue?vue&type=script&lang=js&"
export * from "./AddSquad.vue?vue&type=script&lang=js&"
import style0 from "./AddSquad.vue?vue&type=style&index=0&id=e4496566&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4496566",
  null
  
)

export default component.exports